  import Text from 'antd/lib/typography/Text';
import React from 'react';
import styled from 'styled-components';
import { FixedWidth } from './PlanComponent';
  import {AppUser, Maybe} from "../../types";
  import {has_access_to_study} from "../../utils/user";

type Props = {};

const StyledMetadata = styled.div`
display: flex;
width: 100%;
padding: 10px 2.5px;

`;

const columns = [
  'Nombre',
  'Fecha de creación',
  'Tipo',
  'Estrellas',
  'Productos Aplicables',
  'Estatus',
  'Descargar',
];

export default function FileMetadata({user} : {user: Maybe<AppUser>}) {
  return (
    <StyledMetadata>
      {
        columns.filter(value => {
          if (has_access_to_study(user)) {
            return true;
          } else {
            return !(['Estrellas', 'Productos Aplicables', 'Descargar'].includes(value))
          }
        }).map((column, i) => (
          <FixedWidth
            key={`${column}_${i}`}
          >
            <Text
              strong={true}
            >
              {column}
            </Text>
          </FixedWidth>
        ))
      }
    </StyledMetadata>
  );
}
